import { useState } from "react";
import { X } from "lucide-react";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import { Reveal } from "../components/Reveal";
import { galleryImages, snowImages, kitchenImage, lawnImages } from "../data/site";

const allImages = [...galleryImages, ...lawnImages, kitchenImage, snowImages.trucks, snowImages.plow, snowImages.clearing];

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="gallery-page">
      <PageHero
        overline="Portfolio"
        title="Our work, up close."
        subtitle="A look at the outdoor spaces we've transformed across Alberta — from patios and stonework to full seasonal care."
        image={galleryImages[2]}
      />

      <section className="py-24 md:py-32 bg-bone">
        <div className="container-fl">
          <div className="columns-2 md:columns-3 gap-4 space-y-4">
            {allImages.map((img, i) => (
              <Reveal key={i} delay={(i % 3) * 0.05}>
                <button
                  onClick={() => setActive(img)}
                  data-testid={`gallery-item-${i}`}
                  className="block w-full overflow-hidden group break-inside-avoid"
                >
                  <img src={img} alt={`Project ${i + 1}`} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[100] bg-forest-deep/95 flex items-center justify-center p-6"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-6 right-6 text-bone" aria-label="Close" data-testid="lightbox-close">
            <X size={32} />
          </button>
          <img src={active} alt="Selected project" className="max-h-[88vh] max-w-full object-contain" />
        </div>
      )}

      <CtaBanner />
    </div>
  );
};

export default Gallery;
